import { UserProfile } from 'fitbeat.gym-core';
import { ProgramType } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, SafeAreaView, StyleSheet, View } from 'react-native';
import { Button, ButtonTypes } from '../components';
import Theme, { ThemeType } from '../theme';
import { showError } from '../ui';
import { Logger, UserDataConsumer, isWeb } from '../utils';
import { LongTermGoalDescription, OnBoardingProgress } from './components';

interface IProps {
  t: (key: string) => string;
  user: any;
  navigation: any;
}

class GoalDescription extends PureComponent<IProps, {}> {
  public state = {
    isLoading: false,
  };

  public saveGoal = async () => {
    try {
      const longTermGoal = this.props.navigation.getParam('longTermGoal', ProgramType.NotSet);
      this.setState({ isLoading: true });
      const { userProfile, userProfileService } = this.props.user;
      userProfile.longTermGoal = longTermGoal;
      await userProfileService.updateUserProfile(userProfile);

      if (!UserProfile.hasSkillLevel(userProfile)) {
        return this.props.navigation.navigate('SkillLevel');
      }

      const screenToNavigateTo = isWeb() ? 'HomeInstallAppScreen' : 'HomeLoading';
      this.props.navigation.navigate(screenToNavigateTo);
    } catch (error) {
      showError('Oops, something went wrong.');
      Logger.notify(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  public goToGoalList = () => {
    this.props.navigation.navigate('LongTermGoal');
  }

  public render() {
    const { t } = this.props;
    const { isLoading } = this.state;
    const longTermGoal = this.props.navigation.getParam('longTermGoal', ProgramType.NotSet);
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: Theme.WHITE }}>
        <OnBoardingProgress step={5} />
        <View style={styles.containerStyle}>
          <LongTermGoalDescription
            theme={ThemeType.light}
            longTermGoal={longTermGoal}
          />
          <View style={styles.footer}>
            {isLoading ?
              <ActivityIndicator animating color={Theme.PRIMARY} />
              :
              <View style={{ padding: 15, flexDirection: 'row' }}>
                <Button
                  title={t('bookings:back')}
                  isLoading={isLoading}
                  fontColor={Theme.PRIMARY}
                  containerStyle={{ flex: 0.3, marginRight: 10 }}
                  onPress={this.goToGoalList}
                  buttonType={ButtonTypes.OUTLINE}
                />
                <Button
                  title={t('next')}
                  isLoading={isLoading}
                  fontColor={Theme.WHITE}
                  containerStyle={{ flex: 0.7 }}
                  onPress={this.saveGoal}
                  buttonType={ButtonTypes.NORMAL}
                />
              </View>
            }
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    flex: 1,
    height: '90%',
    backgroundColor: Theme.WHITE,
  },
  listContainer: {
    paddingTop: 10,
  },
  footer: {
    paddingVertical: 20,
  },
});

export const LongTermGoalDescriptionScreen =
  UserDataConsumer(translate(['auth', 'formFields'], { wait: true })(GoalDescription));
